module.exports = __webpack_public_path__ + "img/mobile_icon.0cd9c907.png";